import { isMobile } from "./isMobile";

/*
 *
 * ----------------------------------------------- */
jQuery(window).on("load scroll", function () {
  var $home = jQuery("#home");

  if (!$home.length || isMobile()) {
    return false;
  }

  var $scrollspyTarget = jQuery("#navbar .nav-scrollspy");

  $scrollspyTarget.each(function () {
    var container = jQuery(this).attr("href");
    var containerOffset = jQuery(container).offset().top;
    var containerHeight = jQuery(container).outerHeight();
    var containerBottom = containerOffset + containerHeight;
    var scrollPosition = jQuery(document).scrollTop();

    if (
      scrollPosition < containerBottom - 85 &&
      scrollPosition >= containerOffset - 85
    ) {
      jQuery(this).addClass("active");
    } else {
      jQuery(this).removeClass("active");
    }
  });
});
